import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined';
import { Box, styled, useTheme } from '@mui/material';
import { useRef } from 'react';
import CurrencyInput from 'react-currency-input-field';

const NumberBox = styled(Box)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.primary.lighter,
  padding: theme.spacing(1),
}));

export interface CurrencyInputBoxProps {
  defaultValue?: string | number;
  onChange: (value: string) => void;
}

export const CurrencyInputBox = ({ defaultValue, onChange }: CurrencyInputBoxProps) => {
  const theme = useTheme();
  const input = useRef<HTMLInputElement>(null);
  const emitted = useRef(defaultValue === undefined ? '' : String(defaultValue));
  const emit = (value: string) => {
    if (value === emitted.current) return;
    emitted.current = value;
    onChange(value);
  };
  const onlyMinus = () => /^-\$?$/.test(input.current?.value.trim() ?? '');
  return (
    <NumberBox className="flex items-center justify-center">
      <CurrencyInput
        style={{
          background: 'none',
          border: 'none',
          outline: 'none',
          width: 85,
          fontSize: theme.typography.body1.fontSize,
          fontFamily: theme.typography.body1.fontFamily,
          color: theme.palette.text.secondary,
        }}
        prefix="$"
        placeholder="$0.00"
        decimalsLimit={2}
        ref={input}
        // SEE-1897: a lone "-" reports no value. It is a negative amount being typed, into an empty
        // box or over an amount, not a cleared box: passed on, it closed the criterion mid-entry.
        onValueChange={(value) => {
          if (value === undefined && onlyMinus()) return;
          emit(value ?? '');
        }}
        // Leaving a lone "-" blanks the box without reporting it; clear the bound so they match.
        onBlur={() => {
          if (onlyMinus()) emit('');
        }}
        defaultValue={defaultValue}
      />

      <ModeEditOutlinedIcon color="primary" />
    </NumberBox>
  );
};
